import {useQuery} from "@apollo/client";
import {GetPublishedIssueDocument, Page} from "generated/graphql";
import Latex from "react-latex-next";
import 'katex/dist/katex.min.css';

interface Props {
  page: Page
}

export const LastIssue = ({ page }: Props) => {
  const { data } = useQuery(GetPublishedIssueDocument);

  return <div>
    <h2>{page.name}</h2>
    <p dangerouslySetInnerHTML={{ __html: page.content ?? ''}}></p>
    <div className="article-list">
      {data?.issue.publishedArticles.map(a => <div key={a.id}>
          {a.authors}
        {a.title.split("\\n").map(l => <div className="title" key={l}><Latex>{l}</Latex></div>)}
        </div>)}
    </div>
  </div>
}